import { memo, FC } from 'react'
import {
  // Select,
  InputGroup,
  // InputLeftAddon,
  Textarea,
} from '@chakra-ui/react'

import { DynamicFieldProps } from '../..'

const InputFilterField: FC<DynamicFieldProps> = ({
  name,
  register,
}) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      {/* <InputLeftAddon p={0} width="max-content">
        <Select placeholder="Selecione uma regra" roundedRight="none" {...register(`${name}_rule`)}>
          <option value="HAVE">Contém</option>
          <option value="NOT_HAVE">Não contém</option>
        </Select>
      </InputLeftAddon> */}

      <Textarea roundedTopLeft="none" {...register(name)} />
    </InputGroup>
  )
}

export default memo(InputFilterField)
